var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"client-details-tab__container"},[_c('Tab',{attrs:{"routes":_vm.tabRoutes}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }